<div class="status-dashboard">
    @if (status()) {
        <div class="status-grid">
            <div class="status-card">
                <div class="card-header">
                    <h3><i class="fas fa-user-plus"></i> User Registration</h3>
                </div>
                <div class="card-content">
                    <div class="stat-row">
                        <span class="stat-label">Today:</span>
                        <span class="stat-value">{{ status()!.registeredToday | number }}</span>
                    </div>
                    <div class="stat-row">
                        <span class="stat-label">This Week:</span>
                        <span class="stat-value">{{ status()!.registeredThisWeek | number }}</span>
                    </div>
                    <div class="stat-row">
                        <span class="stat-label">This Month:</span>
                        <span class="stat-value">{{ status()!.registeredThisMonth | number }}</span>
                    </div>
                    <div class="stat-row">
                        <span class="stat-label">Last Month:</span>
                        <span class="stat-value">{{ status()!.registeredLastMonth | number }}</span>
                    </div>
                </div>
            </div>

            <div class="status-card">
                <div class="card-header">
                    <h3><i class="fas fa-robot"></i> Active Bots</h3>
                </div>
                <div class="card-content">
                    <div class="large-stat">
                        <span class="large-number">{{ status()!.activeBots | number }}</span>
                        <span class="large-label">Currently Active</span>
                    </div>
                </div>
            </div>

            @if (status()!.lastSchedulerRun) {
                <div class="status-card">
                    <div class="card-header">
                        <h3><i class="fas fa-clock"></i> Last Scheduler Run</h3>
                    </div>
                    <div class="card-content">
                        <div class="stat-row">
                            <span class="stat-label">Run ID:</span>
                            <span class="stat-value code">{{ status()!.lastSchedulerRun!.id }}</span>
                        </div>
                        <div class="stat-row">
                            <span class="stat-label">Scheduled:</span>
                            <span class="stat-value">{{
                                status()!.lastSchedulerRun!.scheduledStartAtUtc | date: "medium"
                            }}</span>
                        </div>
                        @if (status()!.lastSchedulerRun!.startedAtUtc) {
                            <div class="stat-row">
                                <span class="stat-label">Started:</span>
                                <span class="stat-value">{{
                                    status()!.lastSchedulerRun!.startedAtUtc | date: "medium"
                                }}</span>
                            </div>
                        }
                        @if (status()!.lastSchedulerRun!.endedAtUtc) {
                            <div class="stat-row">
                                <span class="stat-label">Ended:</span>
                                <span class="stat-value">{{
                                    status()!.lastSchedulerRun!.endedAtUtc | date: "medium"
                                }}</span>
                            </div>
                        }
                        @if (status()!.lastSchedulerRun!.durationSeconds) {
                            <div class="stat-row">
                                <span class="stat-label">Duration:</span>
                                <span class="stat-value">{{
                                    formatDuration(status()!.lastSchedulerRun!.durationSeconds)
                                }}</span>
                            </div>
                        }
                        <div class="stat-row">
                            <span class="stat-label">Bots Processed:</span>
                            <span class="stat-value">{{ status()!.lastSchedulerRun!.botsProcessed | number }}</span>
                        </div>
                        <div class="stat-row">
                            <span class="stat-label">Stocks Purchased:</span>
                            <span class="stat-value success">{{
                                status()!.lastSchedulerRun!.totalPurchasedStocks | number
                            }}</span>
                        </div>
                        <div class="stat-row">
                            <span class="stat-label">Stocks Sold:</span>
                            <span class="stat-value warning">{{
                                status()!.lastSchedulerRun!.totalSoldStocks | number
                            }}</span>
                        </div>
                        @if (status()!.lastSchedulerRun!.schedules.length) {
                            <div class="stat-row">
                                <span class="stat-label">Schedules:</span>
                                <span class="stat-value">
                                    <div class="schedule-tags">
                                        @for (schedule of status()!.lastSchedulerRun!.schedules; track $index) {
                                            <span class="schedule-tag">
                                                {{ schedule }}
                                            </span>
                                        }
                                    </div>
                                </span>
                            </div>
                        }
                    </div>
                </div>
            }

            @if (!status()!.lastSchedulerRun) {
                <div class="status-card">
                    <div class="card-header">
                        <h3><i class="fas fa-clock"></i> Last Scheduler Run</h3>
                    </div>
                    <div class="card-content">
                        <p class="no-data">No recent scheduler run information available</p>
                    </div>
                </div>
            }

            @if (status()!.nextSchedulerRuns.length) {
                <div class="status-card full-width">
                    <div class="card-header">
                        <h3><i class="fas fa-calendar-alt"></i> Upcoming Scheduler Runs</h3>
                    </div>
                    <div class="card-content">
                        <div class="next-runs-list">
                            @for (run of status()!.nextSchedulerRuns; track run.id) {
                                <div class="next-run-item">
                                    <div class="next-run-info">
                                        <div class="run-id">
                                            <fa-icon [icon]="['fas', 'play-circle']"></fa-icon>

                                            <span class="code">{{ run.id }}</span>
                                        </div>
                                        <div class="time-row">
                                            <div class="run-time">
                                                <fa-icon [icon]="['fas', 'clock']"></fa-icon>

                                                {{ run.scheduledStartAtUtc | date: "medium" }}
                                            </div>
                                            <div class="run-countdown">
                                                <app-timer [time]="run.scheduledStartAtUtc"></app-timer>
                                            </div>
                                        </div>
                                        @if (run.schedules.length) {
                                            <div class="run-schedules">
                                                <fa-icon [icon]="['fas', 'tags']"></fa-icon>
                                                <div class="schedule-tags">
                                                    @for (schedule of run.schedules; track $index) {
                                                        <span class="schedule-tag">
                                                            {{ schedule }}
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            @if (!status()!.nextSchedulerRuns.length) {
                <div class="status-card full-width">
                    <div class="card-header">
                        <h3><i class="fas fa-calendar-alt"></i> Upcoming Scheduler Runs</h3>
                    </div>
                    <div class="card-content">
                        <p class="no-data">No upcoming scheduler runs scheduled</p>
                    </div>
                </div>
            }
        </div>
    }
</div>
